import { CLEAR_VALUES, SET_FUNDRAISER, SET_VALUES } from 'actions/types'
import api, { urls } from 'config/api'

export const _setValues = (values) => ({
  type: SET_VALUES,
  values,
})

export const _clearValues = () => ({
  type: CLEAR_VALUES,
})

export const _setFundraiser = (fundraiser) => ({
  type: SET_FUNDRAISER,
  fundraiser,
})

export const setValues = (shortcode, values = {}) => async (
  dispatch,
  getState
) => {
  await dispatch(_setValues(values))
  localStorage.setItem(
    shortcode,
    JSON.stringify({
      values: getState().app,
    })
  )
}

export const loadValues = (shortcode) => async (dispatch, getState) => {
  const { values = {} } =
    JSON.parse(localStorage.getItem(shortcode)) || {}
  await dispatch(_setValues(values))
}

export const getFundraiser = (shortcode) => async (dispatch) => {
  const { data: fundraiser } = await api.get(
    urls.fundraiserShortcode({ shortcode })
  )
  dispatch(_setFundraiser(fundraiser))
  return fundraiser
}

export const getLeaderboard = () => async (dispatch, getState) => {
  const { id } = getState().fundraiser
  const resp = await api.get(urls.fundraiserLeaderboard({ id }))
  return resp.data
}

export const submitOrder = (order) => async (dispatch, getState) => {
  const fundraiser = getState().fundraiser
  const { shortcode } = fundraiser
  const resp = await api.post(urls.orders(), {
    ...order,
    fundraiser: fundraiser.id,
  })
  localStorage.removeItem(shortcode)
  dispatch(_clearValues())
  return resp.data
}
